// extracted by mini-css-extract-plugin
module.exports = {"container":"List_container_1O0wp","batchTable":"List_batchTable_1aN2A","detail":"List_detail_2Zxw9"};